import styled from '@emotion/styled/macro';
import { Popover, Variables } from '@enter/core';
import { Icon } from '@mdi/react';
import { Link } from 'react-router-dom';

export const StyledPopover = styled(Popover)``;

export const ActionButton = styled.button`
    cursor: pointer;
    outline: none;

    display: inline-flex;
    align-items: center;

    font-size: 14px;
    letter-spacing: 0.2px;
    padding: 6px 12px;

    color: ${Variables.Colors.b300_l62};
    background-color: ${Variables.Colors.b300_l96};
    border: 1px solid ${Variables.Colors.b300_l90};
    border-radius: 3px;
    overflow: hidden;

    &:hover {
        cursor: pointer;
        border-color: ${Variables.Colors.b300_l76};
    }
`;

export const ActionButtonIcon = styled(Icon)`
    margin-left: 2px;
    height: 18px;
    width: 18px;
    vertical-align: text-bottom;
    fill: ${Variables.Colors.b300_l62};
`;

export const LinkItem = styled(Link)`
    color: inherit;
`;
